import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p className={`text-xs md:text-sm uppercase tracking-[0.25em] ${dark ? "text-amber-2" : "text-amber"}`}>
    {children}
  </p>
);

export const Logo = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <circle cx="32" cy="24" r="12" fill="#b45309" />
    <path d="M9 42c7-7 14-7 21 0s14 7 23 0" stroke="#f2ede3" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M13 52c6-6 12-6 18 0" stroke="#b45309" strokeWidth="3.5" strokeLinecap="round" opacity="0.55" />
  </svg>
);
